import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getApiCall } from "../../services/apiHelper";
import { baseUrl } from "../../config/config";

interface DocumentSectionsState {
  sections: string[];
  loading: boolean;
  error: string | null;
}

const initialState: DocumentSectionsState = {
  sections: [],
  loading: false,
  error: null,
};

export const fetchDocumentSections = createAsyncThunk(
  "documentSections/fetch",
  async (sectionKey: string) => {
    const response:any = await getApiCall(`${baseUrl}MasterConfig/GetMasterDataByKey?key=${sectionKey}`);
    const data = response;
    return typeof data === 'string' ? data.split(';') : [];
  }
);

const documentSectionsSlice = createSlice({
  name: "documentSections",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentSections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentSections.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.loading = false;
        state.sections = action.payload.filter(s => s.trim() !== '');
      })
      .addCase(fetchDocumentSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch document sections";
      });
  },
});

export default documentSectionsSlice.reducer;
